let l, t = {}, o = { default: "UTC", current: "UTC" };
const a = (e) => {
  l = e.logger, t = e.callbacks || {}, o = e.timezone;
};
export {
  t as callbacks,
  a as initConfig,
  l as logger,
  o as timezone
};
